export default __webpack_public_path__ + "static/media/WhiteExit.4975fbae.svg";